export const getTrendCursors = (ecmodel) => {
    var _a;
    // sometimes echarts just maps off an option to null on delete
    const trendCursors = ((_a = ecmodel.getOption().trendCursors) !== null && _a !== void 0 ? _a : []).filter((model) => !!model);
    return trendCursors;
};
